
import { Component, Vue } from 'vue-property-decorator';

import mainStore from '@/store/main-store/MainStore';

import { User } from '../../webservices/models';

@Component({
    name: 'FavUsersTable',
})
export default class FavUsersTable extends Vue {
    private mainStore = mainStore.context(this.$store);

    private nickname: string = '';

    private get favUsers(): User[] {
        return this.mainStore.state.favUsers;
    }

    private get favUsersToDownload(): object[] {
        return this.mainStore.getters.favUsersToDownload;
    }

    private uploadApiFavUsers(): void {
        this.mainStore.actions.uploadApiFavUsers(this.nickname);
    }
    private getApiFavUsers(): void {
        this.mainStore.actions.getApiFavUsers();
    }

    private addFavUser(user: User): void {
        this.mainStore.actions.updateFavUsers(user);
    }
    private openUser(user: User): void {
        this.mainStore.actions.changeCurrentUser(user);
        this.$router.push({ name: 'User' });
    }
}
